import { Component } from 'react';

import BpkCard from '@skyscanner/backpack-web/bpk-component-card';
import BpkMinusIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/minus';
import BpkPlusIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/plus';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';

import type { PanelsProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/AboutAirlineProps';

import STYLES from './ExpandingCard.module.scss';

type CardState = { expanded: boolean };

class ExpandingCard extends Component<PanelsProps, CardState> {
  constructor(props: PanelsProps) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  onToggleClick = () => {
    this.setState((prevState) => ({ expanded: !prevState.expanded }));
  };

  render() {
    const { expanded } = this.state;

    const ExpandIcon = expanded ? BpkMinusIcon : BpkPlusIcon;
    const textClassName = expanded
      ? STYLES.ExpandingCard__answer
      : STYLES['ExpandingCard__answer--hidden'];

    return (
      <div>
        <BpkCard
          className={STYLES.ExpandingCard__card}
          onClick={this.onToggleClick}
          padded={false}
        >
          <div className={STYLES.ExpandingCard__infoButton}>
            <BpkText
              className={STYLES.ExpandingCard__infoHeader}
              tagName="h2"
              textStyle={TEXT_STYLES.label1}
            >
              {this.props.header}
            </BpkText>
            <ExpandIcon className={STYLES.ExpandingCard__icon} />
          </div>
        </BpkCard>
        <div
          className={`bpk-text bpk-text--base ${textClassName}`}
          /* eslint-disable-next-line react/no-danger */
          dangerouslySetInnerHTML={{ __html: this.props.text }}
        />
      </div>
    );
  }
}

export default ExpandingCard;
